import React, { Component } from 'react';
import { Redirect } from 'react-router-dom';
import Comm from '../comm/comm';
import Context from '../context/context';
import Translation from '../translation/translation';


class ChangePassword extends Component {

    constructor() {
        super();
        if (!Comm.ValidSession())
            return;
        this.state = {
            showErrorEnterPassword: false,
            showErrorPasswordNoMatch: false,
            passwordChanged: false
        };
    }
    
    ChangePassword() {
        if ((this.state.password || "") === "") {
            this.setState({ showErrorEnterPassword: true, showErrorPasswordNoMatch: false, passwordChanged: false });
            return;
        }
        if ((this.state.password || "") !== (this.state.password2 || "")) {
            this.setState({ showErrorEnterPassword: false, showErrorPasswordNoMatch: true, passwordChanged: false });
            return;
        }

        var ctx = Context.GetContext();

        var usr = Comm.ChangePassword({
            session: ctx.Sid,
            username: ctx.username,
            password: this.state.password
        });

        if (Context.ErrorResponse(this.props.history, usr)) {
            return null;
        }

        this.setState({ showErrorEnterPassword: false, showErrorPasswordNoMatch: false, passwordChanged: true });
    }



    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return (<Redirect to="/login" push></Redirect>);
        }
        if (Context.RenderNotOK(this.props.history))
            return null;

        return (

            <div className="panel panel-default">
                <div className="panel-heading">{Translation.Trans("changepassword")}</div>
                <div className="panel-body">
                    <input type="password" className="form-control" placeholder={Translation.Trans("password")} value={this.setState.password} onChange={(e) => this.setState({ password: e.target.value })} /><br />
                    <input type="password" className="form-control" placeholder={Translation.Trans("password")} value={this.setState.password2} onChange={(e) => this.setState({ password2: e.target.value })} /><br />
                    <button onClick={() => this.ChangePassword()} className="btn btn-primary">{Translation.Trans("changepassword")}</button><br />
                    {this.state.showErrorEnterPassword ? <div className="alert alert-danger">{Translation.Trans("passwordmustnotbeempty")}</div> : null}
                    {this.state.showErrorPasswordNoMatch ? <div className="alert alert-danger">{Translation.Trans("passwordsdonotmatch")}</div> : null}
                    {this.state.passwordChanged ? <div className="alert alert-success">{Translation.Trans("passwordchanged")}</div> : null}
                </div>
            </div>

        );
    }

}


export default ChangePassword;


// WEBPACK FOOTER //
// ./src/pages/changepassword.js